import { Drawer, Form, Input, Select } from "antd";
import { AppButton } from "components/button/AppButton";
import {
  LEVEL_LIST,
  COUNTRIES,
} from "constants/general";
import { useGlobalContext } from "stateManagers/GlobalContext";
import { IdentifierProps } from "types";
import { openNotification } from "utils/notification";
import { useState } from "react";
import { useGetSectors } from "features/jobs/hooks/useGetSectors";

const CITIES_API_URL = "https://countriesnow.space/api/v0.1/countries/cities";

export const FilterFolder = ({ open, handleClose }: IdentifierProps) => {
  const { filterFolderState, setFilterFolderState } = useGlobalContext();
  const [form] = Form.useForm();
  const [selectedCountry, setSelectedCountry] = useState<string | null>(null);
  const [filteredCities, setFilteredCities] = useState<any[]>([]);
  const [isFetchingCities, setIsFetchingCities] = useState(false);

  const handleSubmit = (data: any) => {
    const payload: any = {};


    const fieldsToCheck = [
      "title",
      "location_country",
      "location_city",
      "gender",
      "visibility_score",
      "skills",
      "experience_level",
      "sector",
      "relocate",
    ];


    fieldsToCheck.forEach((field) => {
      if (data[field]) {
        payload[field] = data[field];
      }
    });

    if (Object.keys(payload).length > 0) {
      setFilterFolderState({
        ...filterFolderState,
        ...payload,
      });
      handleClose();
    } else {
      openNotification({
        state: "error",
        title: "Error",
        description: "Please filter with at least 1 value",
        duration: 4.5,
      });
    }
  };

  const fetchCities = async (countryCode: string) => {

    try {
      const response = await fetch(CITIES_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          country: countryCode,
        }),
      });

      const data = await response.json();


      if (response.ok) {
        setFilteredCities(data.data);
      } else {
        console.error("Failed to fetch cities:", data);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  const handleCountryChange = (value: string) => {
    setSelectedCountry(value);
    setFilteredCities([]);
    const country = COUNTRIES.find((country) => country.name === value);
    if (country) {
      fetchCities(country.name);
    }
    form.setFieldsValue({ location_city: undefined });
  };


  return (
    <Drawer open={open} onClose={() => handleClose()} title="Filter Jobs">
      <Form layout="vertical" onFinish={handleSubmit} form={form}>

        <Form.Item name="title" label="Job Title">
          <Input placeholder="e.g. Software Engineer" allowClear />
        </Form.Item>

        <Form.Item name="location_country" label="Location (Country)">
          <Select
            allowClear
            placeholder="Select"
            showSearch
            options={COUNTRIES.map((country) => ({
              value: country.name,
              label: country.name,
            }))}
            onChange={handleCountryChange}
          />
        </Form.Item>

        <Form.Item name="location_city" label="Location (City)">
          <Select
            showSearch
            allowClear
            placeholder="Select"
            disabled={!selectedCountry || isFetchingCities}
            loading={isFetchingCities}
            options={filteredCities.map((city) => ({
              value: city,
              label: city,
            }))}
          />
        </Form.Item>

        <Form.Item name="skills" label="Skills & Competencies">
          <Input placeholder="e.g. JavaScript, React" allowClear />
        </Form.Item>

        <Form.Item name="experience_level" label="Experience Level">
          <Select allowClear placeholder="Select" options={LEVEL_LIST} />
        </Form.Item>

        <div className="flex items-center justify-end gap-4 mt-6">
          <AppButton type="reset" label="Reset" variant="transparent" />
          <AppButton type="submit" label="Apply" />
        </div>
      </Form>
    </Drawer>
  );
};
